import { z } from 'zod'

/**
 * Schema de validacao das variaveis de ambiente.
 * Executado no startup da aplicacao (main.tsx) para fail-fast.
 */
const envSchema = z.object({
  // Supabase (obrigatorias)
  VITE_SUPABASE_URL: z.string().url('VITE_SUPABASE_URL deve ser uma URL valida'),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, 'VITE_SUPABASE_ANON_KEY e obrigatoria'),

  // Evolution API (obrigatorias)
  VITE_EVOLUTION_V2_URL: z.string().url('VITE_EVOLUTION_V2_URL deve ser uma URL valida'),
  VITE_EVOLUTION_V2_APIKEY: z.string().min(1, 'VITE_EVOLUTION_V2_APIKEY e obrigatoria'),

  // App (obrigatorias)
  VITE_PUBLIC_URL: z.string().url('VITE_PUBLIC_URL deve ser uma URL valida'),

  // Sentry (opcionais)
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_APP_VERSION: z.string().optional(),

  // AI Module (opcionais)
  VITE_AI_PROVIDER: z.enum(['openai', 'anthropic']).optional(),
  VITE_OPENAI_API_KEY: z.string().optional(),
  VITE_ANTHROPIC_API_KEY: z.string().optional(),
  VITE_AI_MODULE_ENABLED: z.enum(['true', 'false']).optional(),

  // Feature flags (opcionais)
  VITE_CASA_DOS_DADOS_ENABLED: z.enum(['true', 'false']).optional(),
  VITE_APP_NAME: z.string().optional(),
})

type Env = z.infer<typeof envSchema>

function validateEnv(): Env {
  const result = envSchema.safeParse(import.meta.env)

  if (!result.success) {
    const errors = result.error.flatten().fieldErrors
    const formatted = Object.entries(errors)
      .map(([key, msgs]) => `  ${key}: ${msgs?.join(', ')}`)
      .join('\n')

    console.error(
      `[env] Variaveis de ambiente invalidas:\n${formatted}\n\n` +
      'Verifique seu arquivo .env e garanta que todas as vars obrigatorias estao definidas.'
    )

    // Em dev, logar mas nao crashar (pode estar sem .env)
    if (import.meta.env.DEV) {
      return import.meta.env as unknown as Env
    }

    throw new Error(`Variaveis de ambiente invalidas:\n${formatted}`)
  }

  return result.data
}

export const env = validateEnv()
